import { render, staticRenderFns } from "./HistoricoTab.vue?vue&type=template&id=dbea797e"
import script from "./HistoricoTab.vue?vue&type=script&lang=js"
export * from "./HistoricoTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports